module.exports = __webpack_public_path__ + "static/ZEP3_Kurzinfo-25b3a2f943d21fa60afcdab0b6ad579c.pdf";